import { useEffect, useState } from "react";

import { useTranslation } from "next-i18next";

import { Heading } from "@/ui/cva/Heading";
import Spinner from "@/ui/spinner";
import { Body } from "@/ui/typography/Body";

/** Recognition takes about this long; then the line moves on to the sales. */
const RECOGNISING_MS = 8000;

/** While the check runs: the photo, and what we are doing ("first what it is, then the sales"). */
export const ValueCheckChecking = ({ photoUrl }: { photoUrl: string }) => {
  const { t } = useTranslation();
  const [findingSales, setFindingSales] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFindingSales(true), RECOGNISING_MS);

    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      className="grid justify-items-center gap-6 py-6 text-center"
      aria-busy="true"
    >
      {/* eslint-disable-next-line @next/next/no-img-element -- a local object URL, not a remote image */}
      <img
        src={photoUrl}
        alt=""
        className="max-h-80 w-auto rounded object-contain"
      />
      <Heading as="h1" size="h3">
        {t("value-check:checking-title", "We're looking at your photo")}
      </Heading>
      <div className="flex items-center gap-2" role="status">
        <Spinner className="size-5 text-brand-500" />
        <Body className="text-grey-800">
          {findingSales
            ? t("value-check:checking-sales", "Looking for comparable sales")
            : t("value-check:checking-recognising", "Working out what it is")}
        </Body>
      </div>
    </section>
  );
};
